module.exports = __webpack_public_path__ + "img/two2Red.7526436f.jpg";